import { Tag } from "antd";
import _ from "lodash";
import React from "react";

import { convertFormatDate } from "@utils/convertFormatDate";

const BASE_ACTION_LOGS_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Username",
    dataIndex: ["user", "username"],
    key: "username",
    fixed: "left",
  },
  {
    title: "Action Type",
    dataIndex: "action_type",
    key: "action_type",
    fixed: "left",
    align: "center",
    render: (action_type) => {
      let color;
      switch (action_type) {
        case "LOGIN":
          color = "success";
          break;
        case "LOGOUT":
          color = "purple";
          break;
        case "CREATE":
          color = "processing";
          break;
        case "UPLOAD":
          color = "processing";
          break;
        case "UPDATE":
          color = "warning";
          break;
        case "DELETE":
          color = "error";
          break;
        default:
          color = "default";
      }
      return <Tag color={color}>{action_type}</Tag>;
    },
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "Customer",
    dataIndex: ["categoryCustomer", "customer_name"],
    key: "categoryCustomer",
  },
  {
    title: "Time",
    dataIndex: "created_at",
    key: "time",
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    render: (created_at) => {
      const formattedTime = convertFormatDate({ date: created_at });
      return formattedTime;
    },
  },
];

export const getActionLogsTableColumns = ({ userType }) => {
  if (userType === "OWNER") {
    return [...BASE_ACTION_LOGS_TABLE_COLUMNS];
  } else {
    return _.filter(BASE_ACTION_LOGS_TABLE_COLUMNS, (item) => {
      return _.get(item, ["key"]) !== "categoryCustomer";
    });
  }
};
